import React, { useEffect, useRef, useState } from "react"
import Loader from "react-loaders"
import colors from "utils/colors"
import api from "services/api.service"
import { userService } from "services/user.service"
import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"

const ObjectivesGrid = ({
  objectives,
  measures,
  isLoading,
  setObjective,
  toggleEditModal,
  reloadGrid,
  addMeasure,
  scenario,
  objTypes,
}) => {
  var gridRef = useRef(null)
  const currentUser = userService.getLoggedInUser()

  const onAddMeasure = objectiveId => {
    addMeasure(objectiveId)
  }

  const handleNamePress = (e, objective) => {
    e && e.preventDefault()
    console.log(objective)
    if (objective.measureID !== undefined) {
      let obj = objectives.find(
        x => x.measures.find(m => m.measureID == objective.measureID) != null
      )
      setObjective({
        ...objective,
        objectiveID: obj.objectiveID,
      })
    } else {
      setObjective(objective)
    }
    toggleEditModal()
  }

  const onMoveDown = async (e, rowData) => {
    e && e.preventDefault()
    if (rowData.measureID !== undefined) {
      let objWithMeasure = objectives.find(
        x => x.measures.find(m => m.measureID == rowData.measureID) != null
      )
      let originalMeasure = objWithMeasure.measures.find(
        x => x.measureID == rowData.measureID
      )
      let originalMeasureIdx = objWithMeasure.measures.indexOf(originalMeasure)
      let nextMeasure = objWithMeasure.measures[originalMeasureIdx + 1]
      if (nextMeasure != undefined) {
        let temp = nextMeasure.orderNum
        nextMeasure.orderNum = originalMeasure.orderNum
        originalMeasure.orderNum = temp

        await api.updateMeasure(currentUser.userID, originalMeasure)
        await api.updateMeasure(currentUser.userID, nextMeasure)
        await reloadGrid(true)
      }
    } else {
      let originalObj = objectives.find(
        x => x.objectiveID == rowData.objectiveID
      )
      let originalObjIdx = objectives.indexOf(originalObj)
      let nextObj = objectives[originalObjIdx + 1]
      if (nextObj != undefined) {
        let temp = nextObj.orderNum
        nextObj.orderNum = originalObj.orderNum
        originalObj.orderNum = temp
        await api.updateObjective(currentUser.userID, originalObj)
        await api.updateObjective(currentUser.userID, nextObj)
        await reloadGrid(true)
      }
    }
  }

  const onMoveUp = async (e, rowData) => {
    e && e.preventDefault()
    if (rowData.measureID !== undefined) {
      let objWithMeasure = objectives.find(
        x => x.measures.find(m => m.measureID == rowData.measureID) != null
      )
      let originalMeasure = objWithMeasure.measures.find(
        x => x.measureID == rowData.measureID
      )
      let originalMeasureIdx = objWithMeasure.measures.indexOf(originalMeasure)
      let prevMeasure = objWithMeasure.measures[originalMeasureIdx - 1]
      if (prevMeasure != undefined) {
        let temp = prevMeasure.orderNum
        prevMeasure.orderNum = originalMeasure.orderNum
        originalMeasure.orderNum = temp

        await api.updateMeasure(currentUser.userID, originalMeasure)
        await api.updateMeasure(currentUser.userID, prevMeasure)
        await reloadGrid(true)
      }
    } else {
      let originalObj = objectives.find(
        x => x.objectiveID == rowData.objectiveID
      )
      let originalObjIdx = objectives.indexOf(originalObj)
      let prevObj = objectives[originalObjIdx - 1]
      if (prevObj != undefined) {
        let temp = prevObj.orderNum
        prevObj.orderNum = originalObj.orderNum
        originalObj.orderNum = temp
        await api.updateObjective(currentUser.userID, originalObj)
        await api.updateObjective(currentUser.userID, prevObj)
        await reloadGrid(true)
      }
    }
  }

  const columns = [
    {
      field: "objectiveID",
      headerText: "ID",
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "orderNum",
      headerText: "Order",
    },
    {
      headerText: "Objective",
      field: "objectiveName",
      width: "30%",
      //   headerFilter: "input",
      template: data => (
        <a
          style={{ width: "100px", display: "inline-block" }}
          href="#"
          onClick={e => handleNamePress(e, data)}
        >
          {data.objectiveName}
        </a>
      ),
    },
    {
      headerText: "Type",
      field: "objTypeID",
      width: "20%",
      template: data => {
        let objType = objTypes.find(x => x.listItemID == data.objTypeID)

        return objType?.listItemName ?? ""
      },
    },
    {
      headerText: "Auto Calc",
      field: "autoScore",
      width: "10%",
      template: data => {
        return data.autoScore == true ? "Yes" : "No"
      },
      filter: {
        type: "Excel",
        itemTemplate: data => (data.autoScore == true ? "Yes" : "No"),
      },
    },
    // {
    //   headerText: "Select",
    //   formatter: "rowSelection",
    //   // titleFormatter: "rowSelection",
    //   titleFormatter: function (cell, formatter) {
    //     cell.getElement().classList.add("text-center")
    //     return cell.getValue()
    //   },
    //   hozAlign: "center",
    //   headerSort: false,
    //   cellClick: function (e, cell) {
    //     cell.getRow().toggleSelect()
    //   },
    //   width: 100,
    // },
    {
      headerText: `Add ${scenario.subCriteriaName}`,
      field: "objectiveID",
      width: "20%",
      template: data => {
        if (data.measureID !== undefined) {
          return null
        }
        if (data.objTypeID > 0) {
          return null
        }
        return (
          <button
            className="btn btn-primary btn-sm"
            onClick={e => onAddMeasure(data.objectiveID)}
          >
            + Add {scenario.subCriteriaName}
          </button>
        )
      },
    },
    {
      headerText: "Move",
      field: "objectiveID",
      width: "20%",
      template: data => (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <a
            href="#"
            onClick={e => onMoveUp(e, data)}
            style={{ fontSize: "13px" }}
          >
            <i className="fas fa-arrow-up"></i> Up
          </a>
          <a
            href="#"
            style={{ marginLeft: "10px", fontSize: "13px" }}
            onClick={e => onMoveDown(e, data)}
          >
            <i className="fas fa-arrow-down"></i> Down
          </a>
        </div>
      ),
    },
  ]

  return (
    <React.Fragment>
      {isLoading && (
        <Loader
          type="line-scale-pulse-out"
          color={colors.primary}
          style={{ textAlign: "center" }}
        />
      )}
      {!isLoading && objectives.length > 0 && (
        <SyncfusionGrid
          dataBound={() => {
            const parentData = gridRef.current?.dataSource
            if (parentData && parentData.length > 0) {
              parentData.forEach((row, index) => {
                const matchingChildren = measures.filter(
                  m => row.objectiveID == m.objectiveID
                )

                if (matchingChildren.length > 0) {
                  gridRef.current.detailRowModule.expand(index)
                }
              })
            }
          }}
          gridRef={gridRef}
          columns={columns}
          data={objectives}
          sortSettings={{
            columns: [{ field: "orderNum", direction: "Ascending" }],
          }}
          childGrid={{
            columns: [
              {
                field: "orderNum",
                headerText: "Order",
                width: "10%",
              },
              {
                headerText: "Measure",
                field: "measureName",
                width: "20%",
                template: data => {
                  const value = data.measureName
                  return value ? value : "—"
                },
              },
              {
                headerText: "Type",
                field: "objTypeID",
                width: "50%",
                template: data => {
                  let objType = objTypes.find(
                    x => x.listItemID == data.objTypeID
                  )

                  return objType?.listItemName ?? ""
                },
              },
              {
                headerText: "Move",
                field: "measureID",
                width: "20%",
                template: data => (
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <a
                      href="#"
                      onClick={e => onMoveUp(e, data)}
                      style={{ fontSize: "13px" }}
                    >
                      <i className="fas fa-arrow-up"></i> Up
                    </a>
                    <a
                      href="#"
                      style={{ marginLeft: "10px", fontSize: "13px" }}
                      onClick={e => onMoveDown(e, data)}
                    >
                      <i className="fas fa-arrow-down"></i> Down
                    </a>
                  </div>
                ),
              },
            ],
            dataSource: measures,
            queryString: "objectiveID",
            rowHeight: 40,
          }}
        />
      )}
    </React.Fragment>
  )
}

export default ObjectivesGrid
